
    require('./graphic');
    require('../zrender').registerPainter('vml', require('./Painter'));



//////////////////
// WEBPACK FOOTER
// ./~/zrender/lib/vml/vml.js
// module id = 642
// module chunks = 1